import { TRANSFER_GROUP_MODULE } from '@app/routes';

export const TRANSFER_GROUP_ROUTER_REGEX = {
  groupChildPage: new RegExp(
    `^/${TRANSFER_GROUP_MODULE}/[0-9a-zA-Z]{24}/(add|[0-9a-zA-Z]{24})`,
    'i',
  ),
  groupAddChildPage: new RegExp(
    `^/${TRANSFER_GROUP_MODULE}/[0-9a-zA-Z]{24}/add`,
    'i',
  ),
};
